import * as yup from 'yup'

export class InboundTripPAPSSignedForeignShippersDto {
  signedForeignShippersFile?: File = undefined
  signedForeignShippersFileName?: string = undefined
}

export const inboundTripPAPSSignedForeignShippersValidationSchema = yup.object({
  signedForeignShippersFile: yup
    .mixed()
    // @ts-ignore
    .test('Signed Foreign Shippers is required.', 'File ', (value: File) => value)
    .required('Signed Foreign Shippers is required.')
})
